import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FireBaseService } from '../services/fire-base.service';

@Injectable()
export class RegisterGuard implements CanActivate {
  constructor(
    private fireBaseService: FireBaseService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    return (
      this.fireBaseService.phoneRegistered ||
      this.router.parseUrl('auth/register')
    );
  }
}
